/** @module Specification/SizeMap/_ControllerMixin */
define([
	"dojo/_base/declare",
	"Apparel/ProductSize/SizeSet"
], function(declare,SizeSet) {

	return declare(null, {
		/**
		 * @override
		 * Pass SizeSet properties to popup view
		 */
		onCreatePopupParams: function(params) {
			var cache = this.m_cache;
			var node = this.getNode();
			var targetSizeRange = cache.get(node.TargetSizeRange);

			params.bomSizeSet = new SizeSet(cache, targetSizeRange.Sizes);
		},

		/**
		 * @override
		 * Add the dependency path to load the Dimension 1&2 and other related nodes
		 */
		onDependencyPaths: function(paths) {
			paths.push("Child:SizeMapSizes/Child:SourceSize");
			paths.push("Child:TargetSizeRange/Child:Sizes/Child:Dimension1Size;Dimension2Size");
			this.inherited(arguments);
		}
	});
});